module.exports = "/images/icon-grid-inactive.svg?fc9137a807ee10f5f5cb3919afa7c882";